import { render, staticRenderFns } from "./ShopDialog.vue?vue&type=template&id=3b75dedb&scoped=true&"
import script from "./ShopDialog.vue?vue&type=script&lang=js&"
export * from "./ShopDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShopDialog.vue?vue&type=style&index=0&id=3b75dedb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75dedb",
  null
  
)

export default component.exports